<template>
  <div class="container flex-column flex-justify-start flex-align-center">
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==1">
      <div class="submenu flex-row flex-justify-start flex-align-start">
        <div class="sm-item" :class="[{'sm-item-sel': mainpage.form.devtype=='水表'}]" @click="mainpage.form.devtype='水表'">水表</div>
        <div class="sm-item" :class="[{'sm-item-sel': mainpage.form.devtype=='电表'}]" @click="mainpage.form.devtype='电表'">电表</div>
        <div class="sm-item" :class="[{'sm-item-sel': mainpage.form.devtype=='冷气表'}]" @click="mainpage.form.devtype='冷气表'">冷气表</div>
        <div class="sm-item" :class="[{'sm-item-sel': mainpage.form.devtype=='流量计'}]" @click="mainpage.form.devtype='流量计'">流量计</div>
      </div>
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属厂区：</div>
          <el-select v-model="mainpage.form.changqu" placeholder="请选择" @change="handleChangqu" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.changqu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼号：</div>
          <el-select v-model="mainpage.form.louhao" placeholder="请选择" @change="handleLouhao" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louhao"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼层：</div>
          <el-select v-model="mainpage.form.louceng" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louceng"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">抄表方式：</div>
          <el-select v-model="mainpage.form.paratype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.paratype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">开始日期：</div>
          <el-date-picker
            v-model="mainpage.startTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">结束日期：</div>
          <el-date-picker
            v-model="mainpage.endTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称：</div>
          <el-input v-model="mainpage.form.sn" placeholder="设备名称" style="width: 250px"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属公司：</div>
          <el-select v-model="mainpage.form.company" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.company"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="hadleMeterSearch">查询</el-button>
        </div>
      </div>
      <div class="data-display flex-column flex-justify-start flex-align-center">
        <div class="data-bs">
          <el-button type="success" icon="el-icon-plus" style="font-size: 14px; padding: 11px;margin-left: 20px;" @click="handleAdd">新增表具</el-button>
        </div>
        <div class="gird-area flex-row flex-justify-start flex-align-start">
          <el-table :data="mainpage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="installdata" label="安装日期"></el-table-column>
            <el-table-column prop="location" label="安装位置" width="300"></el-table-column>
            <el-table-column prop="initvalue" label="初始值" width="100"></el-table-column>
            <el-table-column prop="scale" label="精度" width="100"></el-table-column>
            <el-table-column prop="rate" label="倍率" width="100"></el-table-column>
            <el-table-column prop="changjia" label="设备厂家"></el-table-column>
            <el-table-column prop="company1" label="所属公司(占比)"></el-table-column>
            <el-table-column prop="paratype" label="抄表方式"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="查看" placement="top-start">
                  <i class="el-icon-document" @click="handleView(scope.row)" style="cursor: pointer; font-size: 18px;"></i>
                </el-tooltip>
                <el-tooltip effect="light" content="编辑" placement="top-start">
                  <i class="el-icon-edit" @click="handleEdit(scope.row)" style="cursor: pointer; font-size: 18px; margin-left: 5px;"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="mainpage.form.totalpage"
            :current-page.sync="mainpage.form.currpage"
            :page-size="mainpage.form.pagesize"
            @current-change="handleMainPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==2">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">新增表具</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-form label-position="right" label-width="150px">
            <el-form-item label="设备名称：" :rules="{required: true}">
              <el-input v-model="editpage.form.name" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备编号：" :rules="{required: true}">
              <el-input v-model="editpage.form.sn" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="表具类型：" :rules="{required: true}">
              <el-select v-model="editpage.form.devtype" placeholder="请选择" style="width: 600px">
                <el-option
                  v-for="item in editpage.options.devtype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安装位置：" :rules="{required: true}">
              <el-col :span="6">
                <el-select v-model="editpage.form.changqu" placeholder="请选择" @change="handleEditChangqu" style="width: 180px">
                  <el-option
                    v-for="item in editpage.options.changqu"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-select v-model="editpage.form.louhao" placeholder="请选择" @change="handleEditLouhao" style="width: 180px">
                  <el-option
                    v-for="item in editpage.options.louhao"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-select v-model="editpage.form.louceng" placeholder="请选择" style="width: 180px">
                  <el-option
                    v-for="item in editpage.options.louceng"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="详细位置：">
              <el-input v-model="editpage.form.detail" placeholder="详细位置" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="抄表方式：" :rules="{required: true}">
              <el-select v-model="editpage.form.paratype" placeholder="请选择" style="width: 600px">
                <el-option
                  v-for="item in editpage.options.paratype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产厂家：" :rules="{required: true}">
              <el-input v-model="editpage.form.changjia" placeholder="生产厂家" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="电表归属：" :rules="{required: true}">
              <el-col :span="12">
                <el-select v-model="editpage.form.company" placeholder="请选择" style="width: 300px">
                  <el-option
                    v-for="item in editpage.options.company"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-input v-model="editpage.form.zhanbi" placeholder="占比"></el-input>
              </el-col>
              <el-col :span="2">%</el-col>
            </el-form-item>
            <el-form-item label="初始数据：" :rules="{required: true}">
              <el-input v-model="editpage.form.initvalue" placeholder="初始数据" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="精度：" :rules="{required: true}">
              <el-input v-model="editpage.form.scale" placeholder="精度" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="倍率：" v-if="editpage.form.devtype=='电表'" :rules="{required: true}">
              <el-input v-model="editpage.form.rate" placeholder="倍率" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="安装日期：" :rules="{required: true}">
              <el-date-picker
                v-model="editpage.installdata"
                type="date"
                placeholder="选择日期"
                style="width: 600px">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <div style="text-align: right;width: 100%;">
                <el-button type="primary" @click="saveAddMeter">保存</el-button>
                <el-button type="primary" @click="changeSubindex(1)">取消</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==3">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">查看</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-form label-position="right" label-width="150px">
            <el-form-item label="设备名称：">
              <el-input v-model="viewpage.row.name" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备编号：">
              <el-input v-model="viewpage.row.sn" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="表具类型：">
              <el-input v-model="viewpage.row.devtype" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="安装位置：">
              <el-input v-model="viewpage.row.location" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="抄表方式：">
              <el-input v-model="viewpage.row.paratype" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="生产厂家：">
              <el-input v-model="viewpage.row.changjia" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="电表归属：">
              <el-input v-model="viewpage.row.company" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="初始数据：">
              <el-input v-model="viewpage.row.initvalue" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="精度：">
              <el-input v-model="viewpage.row.scale" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="倍率：" v-if="viewpage.row.devtype=='电表'">
              <el-input v-model="viewpage.row.rate" readonly style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="安装日期：">
              <el-input v-model="viewpage.row.installdata" readonly style="width: 600px;"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==4">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">编辑</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-form label-position="right" label-width="150px">
            <el-form-item label="设备名称：" :rules="{required: true}">
              <el-input v-model="editpage.form.name" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备编号：" :rules="{required: true}">
              <el-input v-model="editpage.form.sn" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="表具类型：" :rules="{required: true}">
              <el-select v-model="editpage.form.devtype" placeholder="请选择" style="width: 600px">
                <el-option
                  v-for="item in editpage.options.devtype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安装位置：" :rules="{required: true}">
              <el-col :span="6">
                <el-select v-model="editpage.form.changqu" placeholder="请选择" @change="handleEditChangqu" style="width: 180px">
                  <el-option
                    v-for="item in editpage.options.changqu"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-select v-model="editpage.form.louhao" placeholder="请选择" @change="handleEditLouhao" style="width: 180px">
                  <el-option
                    v-for="item in editpage.options.louhao"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-select v-model="editpage.form.louceng" placeholder="请选择" style="width: 180px">
                  <el-option
                    v-for="item in editpage.options.louceng"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="详细位置：">
              <el-input v-model="editpage.form.detail" placeholder="详细位置" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="抄表方式：" :rules="{required: true}">
              <el-select v-model="editpage.form.paratype" placeholder="请选择" style="width: 600px">
                <el-option
                  v-for="item in editpage.options.paratype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产厂家：" :rules="{required: true}">
              <el-input v-model="editpage.form.changjia" placeholder="生产厂家" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="电表归属：" :rules="{required: true}">
              <el-col :span="12">
                <el-select v-model="editpage.form.company" placeholder="请选择" style="width: 300px">
                  <el-option
                    v-for="item in editpage.options.company"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-input v-model="editpage.form.zhanbi" placeholder="占比"></el-input>
              </el-col>
              <el-col :span="2">%</el-col>
            </el-form-item>
            <el-form-item label="初始数据：" :rules="{required: true}">
              <el-input v-model="editpage.form.initvalue" placeholder="初始数据" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="精度：" :rules="{required: true}">
              <el-input v-model="editpage.form.scale" placeholder="精度" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="倍率：" v-if="editpage.form.devtype=='电表'" :rules="{required: true}">
              <el-input v-model="editpage.form.rate" placeholder="倍率" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="安装日期：" :rules="{required: true}">
              <el-date-picker
                v-model="editpage.installdata"
                type="date"
                placeholder="选择日期"
                style="width: 600px">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <div style="text-align: right;width: 100%;">
                <el-button type="primary" @click="saveEditMeter">保存</el-button>
                <el-button type="primary" @click="changeSubindex(1)">取消</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {getLouhao, getLouCeng, getMeterList, getEditChangqu, getEditLouhao, getEditLouCeng, getEditCompany, saveMeter, editMeter} from '@/api/engery.js'
export default {
  name: 'EngeryManage',
  data() {
    return {
      subindex: 1,
      lastsubindex: 1,
      mainpage: {
        form: {
          changqu: '全部',
          devtype: '水表',
          louhao: '',
          louceng: '',
          paratype: '',
          startTime: '',
          endTime: '',
          sn: '',
          company: '',
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        startTime: null,
        endTime: null,
        tableData: [],
        options: {
          changqu: [],
          paratype: [
            {
              value: '全部',
              label: '全部'
            },
            {
              value: '自动上传',
              label: '自动上传'
            },
            {
              value: '手工抄表',
              label: '手工抄表'
            }
          ],
          louhao: [],
          louceng: [],
          company: []
        }
      },
      editpage: {
        form: {
          name: '',
          sn: '',
          devtype: '',
          changqu: '',
          louhao: '',
          louceng: '',
          detail: '',
          paratype: '',
          changjia: '',
          company: '',
          zhanbi: '',
          initvalue: '',
          scale: '',
          rate: '',
          installdata: ''
        },
        row: {},
        installdata: null,
        options: {
          paratype: [
            {
              value: '自动上传',
              label: '自动上传'
            },
            {
              value: '手工抄表',
              label: '手工抄表'
            }
          ],
          devtype: [
            {
              value: '电表',
              label: '电表'
            },
            {
              value: '水表',
              label: '水表'
            },
            {
              value: '冷气表',
              label: '冷气表'
            },
            {
              value: '流量计',
              label: '流量计'
            }
          ],
          changqu: [],
          louhao: [],
          louceng: [],
          company: []
        }
      },
      viewpage: {
        row: {}
      }
    }
  },
  watch: {
    'mainpage.form.devtype': {
      handler() {
        this.$nextTick(async () => {
          this.hadleMeterSearch()
        })
      }
    }
  },
  async mounted() {
    const companyList = await getEditCompany()
    this.editpage.options.company = companyList.data
    this.mainpage.options.company = [...this.editpage.options.company]
    this.mainpage.options.company.unshift({company_id: 0, value: '全部', label: '全部'})
    this.mainpage.form.company = '全部'
    const changquList = await getEditChangqu()
    this.editpage.options.changqu = changquList.data
    this.mainpage.options.changqu = [...this.editpage.options.changqu]
    this.mainpage.options.changqu.unshift({park_id: "00", value: '全部', label: '全部'})
    const meterList = await getMeterList(this.mainpage.form)
    this.mainpage.tableData = meterList.data
    this.mainpage.form.totalpage = meterList.totalpage
  },
  methods: {
    async handleMainPage(vaule) {
      this.hadleMeterSearch()
    },
    formatDateTime(now, sign) {
      const padZero = n => n < 10 ? `0${n}` : n
      let year = now.getFullYear()
      let month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const hour = padZero(now.getHours())
      const minute = padZero(now.getMinutes())
      const second = padZero(now.getSeconds())
      if(sign == 1) {
        month = padZero(month - 1)
        if(month == 0) {
          year -= 1
          month = 12
        }
      }
      const formatDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      return formatDate
    },
    async hadleMeterSearch() {
      if(this.mainpage.startTime != null) {
        const startTime = this.formatDateTime(this.mainpage.startTime, 0)
        this.mainpage.form.startTime = startTime.substr(0, 10)
      }
      if(this.mainpage.endTime != null) {
        const endTime = this.formatDateTime(this.mainpage.endTime, 0)
        this.mainpage.form.endTime = endTime.substr(0, 10)
      }
      try {
        const meterList = await getMeterList(this.mainpage.form)
        this.mainpage.tableData = meterList.data
        this.mainpage.form.totalpage = meterList.totalpage
      } catch (error) {
        console.error(error)
      }
    },
    async handleChangqu(value) {
      this.mainpage.form.louhao = ''
      this.mainpage.louhao = []
      this.mainpage.form.louceng = ''
      this.mainpage.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.mainpage.options.changqu.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouhao(result[0].park_id)
      if(response.data.length <= 1) {
        return
      }
      this.mainpage.options.louhao = response.data
      if(this.mainpage.options.louhao.length > 0) {
        this.mainpage.form.louhao = this.mainpage.options.louhao[0].value
      }
    },
    async handleEditChangqu(value) {
      this.editpage.form.louhao = ''
      this.editpage.louhao = []
      this.editpage.form.louceng = ''
      this.editpage.louceng = []
      const result = this.editpage.options.changqu.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getEditLouhao(result[0].park_id)
      if(response.data.length == 0) {
        return
      }
      this.editpage.options.louhao = response.data
    },
    async handleLouhao(value) {
      this.mainpage.form.louceng = ''
      this.mainpage.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.mainpage.options.louhao.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouCeng(result[0].building_id)
      if(response.data.length <= 1) {
        return
      }
      this.mainpage.options.louceng = response.data
      if(this.mainpage.options.louceng.length > 0) {
        this.mainpage.form.louceng = this.mainpage.options.louceng[0].value
      }
    },
    async handleEditLouhao(value) {
        this.editpage.form.louceng = ''
        this.editpage.louceng = []
      const result = this.editpage.options.louhao.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getEditLouCeng(result[0].building_id)
      if(response.data.length == 0) {
        return
      }
      this.editpage.options.louceng = response.data
    },
    async changeSubindex(index) {
      this.lastsubindex = this.subindex
      this.subindex = index
    },
    handleView(param) {
      this.viewpage.row = param
      this.changeSubindex(3)
    },
    handleAdd() {
      const data = {
        name: '',
        sn: '',
        devtype: '',
        changqu: '',
        louhao: '',
        louceng: '',
        detail: '',
        paratype: '',
        changjia: '',
        company: '',
        zhanbi: '',
        initvalue: '',
        scale: '',
        rate: '',
        installdata: ''
      }
      this.editpage.form = data
      this.changeSubindex(2)
    },
    async handleEdit(param) {
      this.changeSubindex(4)
      this.editpage.row = param
      this.editpage.form.name = param.name
      this.editpage.form.sn = param.sn
      this.editpage.form.devtype = param.devtype
      this.editpage.form.changqu = param.changqu
      this.editpage.form.detail = param.detail
      this.editpage.form.paratype = param.paratype
      this.editpage.form.changjia = param.changjia
      this.editpage.form.company = param.company
      this.editpage.form.zhanbi = param.zhanbi
      this.editpage.form.initvalue = param.initvalue
      this.editpage.form.scale = param.scale
      this.editpage.form.rate = param.rate
      this.editpage.form.installdata = param.installdata
      if(this.editpage.form.installdata != null && this.editpage.form.installdata != '') {
        const year = parseInt(this.editpage.form.installdata.substr(0, 4))
        const month = parseInt(this.editpage.form.installdata.substr(5, 2))
        const day = parseInt(this.editpage.form.installdata.substr(8, 2))
        this.editpage.installdata = new Date(year, month - 1, day)
      }
      await this.handleEditChangqu(this.editpage.form.changqu)
      this.editpage.form.louhao = param.louhao
      await this.handleEditLouhao(this.editpage.form.louhao)
      this.editpage.form.louceng = param.louceng
    },
    isNumber(str) {
      return /^[+-]?(\d+\.?\d*|\.\d+)$/.test(str);
    },
    async saveEditMeter() {
      if(this.editpage.installdata == null) {
        this.editpage.form.installdata = ''
      } else {
        const installdata = this.formatDateTime(this.editpage.installdata, 0)
        this.editpage.form.installdata = installdata.substr(0, 10)
      }
      if(this.editpage.form.name == '') {
        this.$message.error('设备名称不能为空')
        return
      } else if(this.editpage.form.sn == '') {
        this.$message.error('设备编号不能为空')
        return
      } else if(this.editpage.form.devtype == '') {
        this.$message.error('表具类型不能为空')
        return
      } else if(this.editpage.form.changqu == '' || this.editpage.form.louhao == '' || this.editpage.form.louceng == '') {
        this.$message.error('安装位置信息不全')
        return
      } else if(this.editpage.form.paratype == '') {
        this.$message.error('抄表方式不能为空')
        return
      } else if(this.editpage.form.changjia == '') {
        this.$message.error('生产厂家不能为空')
        return
      } else if(this.editpage.form.initvalue == '') {
        this.$message.error('初始数据不能为空')
        return
      } else if(this.editpage.form.scale == '') {
        this.$message.error('精度不能为空')
        return
      } else if(this.editpage.form.devtype == '电表' && this.editpage.form.rate == '') {
        this.$message.error('倍率不能为空')
        return
      } else if(this.editpage.form.installdata == '') {
        this.$message.error('安装日期为空')
        return
      }
      if(!this.isNumber(this.editpage.form.scale)) {
        this.$message.error('精度必须为数字')
        return
      }
      if(this.editpage.form.devtype == '电表') {
        if(!this.isNumber(this.editpage.form.rate)) {
          this.$message.error('倍率必须为数字')
          return
        }
      }
      const result = await editMeter(this.editpage.row.iid, this.editpage.form)
      if(result.id) {
        this.$message.success('修改表具成功')
        this.changeSubindex(1)
        this.hadleMeterSearch()
      } else {
        this.$message.error('修改表具失败')
      }
    },
    async saveAddMeter() {
      if(this.editpage.installdata == null) {
        this.editpage.form.installdata = ''
      } else {
        const installdata = this.formatDateTime(this.editpage.installdata, 0)
        this.editpage.form.installdata = installdata.substr(0, 10)
      }
      if(this.editpage.form.name == '') {
        this.$message.error('设备名称不能为空')
        return
      } else if(this.editpage.form.sn == '') {
        this.$message.error('设备编号不能为空')
        return
      } else if(this.editpage.form.devtype == '') {
        this.$message.error('表具类型不能为空')
        return
      } else if(this.editpage.form.changqu == '' || this.editpage.form.louhao == '' || this.editpage.form.louceng == '') {
        this.$message.error('安装位置信息不全')
        return
      } else if(this.editpage.form.paratype == '') {
        this.$message.error('抄表方式不能为空')
        return
      } else if(this.editpage.form.changjia == '') {
        this.$message.error('生产厂家不能为空')
        return
      } else if(this.editpage.form.initvalue == '') {
        this.$message.error('初始数据不能为空')
        return
      } else if(this.editpage.form.scale == '') {
        this.$message.error('精度不能为空')
        return
      } else if(this.editpage.form.devtype == '电表' && this.editpage.form.rate == '') {
        this.$message.error('倍率不能为空')
        return
      } else if(this.editpage.form.installdata == '') {
        this.$message.error('安装日期为空')
        return
      }
      if(!this.isNumber(this.editpage.form.scale)) {
        this.$message.error('精度必须为数字')
        return
      }
      if(this.editpage.form.devtype == '电表') {
        if(!this.isNumber(this.editpage.form.rate)) {
          this.$message.error('倍率必须为数字')
          return
        }
      }
      const result = await saveMeter(this.editpage.form)
      if(result.id) {
        this.$message.success('添加表具成功')
        this.changeSubindex(1)
        this.hadleMeterSearch()
      } else {
        this.$message.error('添加表具失败')
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.data-sample {
  width: 99%;
}
.submenu {
  width: 99%;
  margin-top: 10px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.sm-item {
  font-family: 'Arial';
  font-size: 18px;
  padding: 10px;
  margin-left: 20px;
}
.sm-item:hover {
  cursor: pointer;
}
.sm-item-sel {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-bottom-color: #4660b6;
  color: #4660b6;
}
.data-search {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.data-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 20px;
  padding-bottom: 20px;
}
.data-bs {
  width: 100%;
  margin-top: 20px;
  text-align: left;
}
.gird-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.data-page {
  width: 98%;
}
.hhead {
  width: 100%;
  font-family: 'Arial';
  font-size: 16px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding: 10px;
}
.hheadl {
  width: 50%;
  margin-left: 10px;
}
.hheadr {
  width: 50%;
  margin-right: 10px;
}
.luru-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.4);
  padding-bottom: 20px;
}
</style>
